import React from 'react';

const SearchBar = ({
  searchQuery,
  onSearch,
  onClearSearch,
  placeholderText
}) => {
  return (
    <div className="field">
    <p className="control has-icons-left has-icons-right">
      
      <input
        className="input is-rounded search-nav-input"
        type="text"
        placeholder={placeholderText}
        value={searchQuery}
        onChange={onSearch}
      />
      <span className="icon is-small is-right has-text-success">
        <i className="fa fa-search"> </i>
      </span>
      <span className="icon is-small is-left has-text-success">
        {/* <!--<i className="fa fa-check"></i>--> */}
        {/* <i className="fa fa-spinner fa-pulse fa-fw"> </i>*/}
        {/* style={{ cursor: 'pointer', pointerEvents: 'all' }} */}
        {searchQuery ? (
          <i className="fa fa-close fa-fw " onClick={onClearSearch}>
            {' '}
          </i>
        ) : (
          <i className="fa fa-circle fa-fw"> </i>
        )}
      </span>
      </p>
    </div>
  );
};

export default SearchBar;
